import { createSvg } from '../createSvg';

const InfoCircle = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return <>
        <g id={'contour'}>
            <path
                d='M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
        <g id={'guts'}>
            <path
                d='M12 8V13'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M11.9946 16H12.0036'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
    </>;
};

export default createSvg(
    InfoCircle,
    'info-circle',
);
